import styles from "../../../../styles/pages/Lead/LeadManagement/HistoryPage.module.css";
import React, { useEffect, useState, useCallback, useContext, useRef } from 'react';
import { getLeadActivitiesApi, getLeadLogsApi } from "../../../../utils/api/Lead/Logs/getLeadLogsApi";
import { useParams } from "react-router-dom";
import { LoadingCircle } from "../../../../components/UI/Custom/LoadingCircle";
import { handleError } from '../../../../utils/custom/errorHandler';
import { Notification } from '../../../../components/UI/Notifications';
import { DropdownSelector } from '../../../../components/UI/DropdownSelector';
import { MultiSelectDropdown } from '../../../../components/UI/MultiSelectDropdown';
import { formatDateTime } from "../../../../utils/custom/formatters";
import { LangContext } from "../../../../context/LangContext";
import { ThemeContext } from "../../../../context/ThemeContext";
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';
import VerifiedUserOutlinedIcon from '@mui/icons-material/VerifiedUserOutlined';
import SmartToyOutlinedIcon from '@mui/icons-material/SmartToyOutlined';
import CallOutlinedIcon from '@mui/icons-material/CallOutlined';
import ForumOutlinedIcon from '@mui/icons-material/ForumOutlined';
import HistoryOutlinedIcon from '@mui/icons-material/HistoryOutlined';
import AccountBalanceOutlinedIcon from '@mui/icons-material/AccountBalanceOutlined';
import SyncOutlinedIcon from '@mui/icons-material/SyncOutlined';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FilterListOutlinedIcon from '@mui/icons-material/FilterListOutlined';
import RestartAltOutlinedIcon from '@mui/icons-material/RestartAltOutlined';
import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined';

const translations = {
    ru: {
        loading: "Загрузка...",
        previousPage: "Назад",
        nextPage: "Вперед",
        totalItems: "Всего записей:",
        noData: "Нет записей об активности для этого лида.",
        system: "Система",
        emptyValue: "пусто",
        relatedEntity: "ID объекта",
        showDetails: "Показать изменения",
        hideDetails: "Скрыть изменения",
        actors: {
            admin: "Администратор",
            affiliator: "Аффилиат",
            lead: "Лид",
            bot: "Бот",
            system: "Система",
            platform: "Платформа",
            integration: "Интеграция",
            scheduler: "Планировщик",
        },
        activityEntities: {
            LEAD: "лид",
            COMMENT: "комментарий",
            BALANCE: "баланс",
            TRADE: "сделку",
            TRANSACTION: "транзакцию",
            VERIFICATION: "файл",
            BOT: "бота",
            CALL: "звонок",
            CHAT: "сообщение",
            ACTIVITY: "активность",
            DEPOSIT_METHOD: "метод депозита",
            SYNC: "синхронизацию",
        },
        activityEvents: {
            created: "создал(а)",
            updated: "изменил(а)",
            deleted: "удалил(а)",
            changed: "изменил(а)",
            opened: "открыл(а)",
            closed: "закрыл(а)",
            synced: "синхронизировал(а)",
            failed: "не удалось выполнить",
            close_failed: "не удалось закрыть",
            uploaded: "загрузил(а)",
            verified: "подтвердил(а)",
            rejected: "отклонил(а)",
            replaced: "заменил(а)",
            activated: "активировал(а)",
            deactivated: "деактивировал(а)",
            run_finished: "завершил(а) запуск",
            started: "начал(а)",
            connected: "соединил(а)",
            terminated: "завершил(а)",
            status_changed: "изменил(а) статус",
            logged_in: "вошел(ла) в систему",
            logged_out: "вышел(ла) из системы",
            hidden: "скрыл(а)",
            restored: "восстановил(а)",
            blocked: "заблокировал(а)",
            unblocked: "разблокировал(а)",
            enabled: "включил(а)",
            disabled: "выключил(а)",
            trying: "начал(а)",
            message_from_lead: "отправил(а)",
            message_from_admin: "отправил(а)",
            message_from_system: "отправила",
        },
        actions: {
            createdComment: "добавил(а) комментарий",
            updatedComment: "изменил(а) комментарий",
            deletedComment: "удалил(а) комментарий",
            createdLead: "создал(а) лид",
            updatedLeadField: "изменил(а) поле",
            createdBy: "Создан пользователем:",
            createdBalance: "создал(а) баланс",
            updatedBalance: "изменил(а) баланс",
            createdVerification: "создал(а) статус верификации",
            updatedVerification: "изменил(а) статус верификации",
            createdTrade: "создал(а) сделку",
            updatedTrade: "изменил(а) сделку",
            createdTransaction: "создал(а) транзакцию",
            updatedTransaction: "изменил(а) транзакцию",
        },
        properties: {
            balance: "Баланс",
            bank_liquidity: "Банковская ликвидность",
        },
        filters: {
            title: "Фильтры",
            period: "Период",
            allTime: "За все время",
            today: "Сегодня",
            last7Days: "Последние 7 дней",
            last30Days: "Последние 30 дней",
            custom: "Свой период",
            dateFrom: "Дата с",
            dateTo: "Дата по",
            categories: "Категории",
            initiators: "Инициаторы",
            actions: "Действия",
            apply: "Применить",
            reset: "Сбросить",
            invalidDateRange: "Дата начала не может быть позже даты окончания.",
            actionOptions: {
                created: "Создано",
                changed: "Изменено",
                deleted: "Удалено",
                other: "Другое",
            },
        }
    },
    en: {
        loading: "Loading...",
        previousPage: "Previous",
        nextPage: "Next",
        totalItems: "Total records:",
        noData: "No activity records found for this lead.",
        system: "System",
        emptyValue: "empty",
        relatedEntity: "Entity ID",
        showDetails: "Show changes",
        hideDetails: "Hide changes",
        actors: {
            admin: "Admin",
            affiliator: "Affiliate",
            lead: "Lead",
            bot: "Bot",
            system: "System",
            platform: "Platform",
            integration: "Integration",
            scheduler: "Scheduler",
        },
        activityEntities: {
            LEAD: "lead",
            COMMENT: "comment",
            BALANCE: "balance",
            TRADE: "trade",
            TRANSACTION: "transaction",
            VERIFICATION: "file",
            BOT: "bot",
            CALL: "call",
            CHAT: "message",
            ACTIVITY: "activity",
            DEPOSIT_METHOD: "deposit method",
            SYNC: "synchronization",
        },
        activityEvents: {
            created: "created",
            updated: "updated",
            deleted: "deleted",
            changed: "changed",
            opened: "opened",
            closed: "closed",
            synced: "synchronized",
            failed: "failed",
            close_failed: "failed to close",
            uploaded: "uploaded",
            verified: "verified",
            rejected: "rejected",
            replaced: "replaced",
            activated: "activated",
            deactivated: "deactivated",
            run_finished: "finished running",
            started: "started",
            connected: "connected",
            terminated: "terminated",
            status_changed: "changed the status of",
            logged_in: "logged in",
            logged_out: "logged out",
            hidden: "hid",
            restored: "restored",
            blocked: "blocked",
            unblocked: "unblocked",
            enabled: "enabled",
            disabled: "disabled",
            trying: "started",
            message_from_lead: "sent",
            message_from_admin: "sent",
            message_from_system: "sent",
        },
        actions: {
            createdComment: "added a comment",
            updatedComment: "updated a comment",
            deletedComment: "deleted a comment",
            createdLead: "created a lead",
            updatedLeadField: "updated a field",
            createdBy: "Created by:",
            createdBalance: "created a balance",
            updatedBalance: "updated a balance",
            createdVerification: "created a verification status",
            updatedVerification: "updated a verification status",
            createdTrade: "created a trade",
            updatedTrade: "updated a trade",
            createdTransaction: "created a transaction",
            updatedTransaction: "updated a transaction",
        },
        properties: {
            balance: "Balance",
            bank_liquidity: "Bank liquidity",
        },
        filters: {
            title: "Filters",
            period: "Period",
            allTime: "All time",
            today: "Today",
            last7Days: "Last 7 days",
            last30Days: "Last 30 days",
            custom: "Custom range",
            dateFrom: "Date from",
            dateTo: "Date to",
            categories: "Categories",
            initiators: "Initiators",
            actions: "Actions",
            apply: "Apply",
            reset: "Reset",
            invalidDateRange: "The start date cannot be later than the end date.",
            actionOptions: {
                created: "Created",
                changed: "Changed",
                deleted: "Deleted",
                other: "Other",
            },
        }
    },

};

const ACTOR_TYPES = ['admin', 'affiliator', 'lead', 'bot', 'system', 'platform', 'integration', 'scheduler'];
const HISTORY_ACTIONS = ['created', 'changed', 'deleted', 'other'];

const createHistoryFilterDraft = () => ({
    period: 'all',
    date_from: '',
    date_to: '',
    categories: [],
    actor_types: [],
    actions: [],
});

const createAppliedHistoryFilters = () => ({
    date_from: '',
    date_to: '',
    categories: [],
    actor_types: [],
    actions: [],
});

export const HistoryPage = () => {
    const [activityLog, setActivityLog] = useState([]);
    const [loading, setLoading] = useState(true);
    const [errors, setErrors] = useState({});
    const { id } = useParams();
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [itemsPerPage] = useState(25);
    const [totalItems, setTotalItems] = useState(0);
    const [expandedLogIds, setExpandedLogIds] = useState(() => new Set());
    const [draftFilters, setDraftFilters] = useState(createHistoryFilterDraft);
    const [appliedFilters, setAppliedFilters] = useState(createAppliedHistoryFilters);
    const [filterError, setFilterError] = useState('');
    const logsCacheRef = useRef(createLogsCache(id, getHistoryFiltersKey(appliedFilters)));
    const requestSequenceRef = useRef(0);

    const { langSelected } = useContext(LangContext);
    const { theme } = useContext(ThemeContext);
    const currentTranslation = translations[langSelected] || translations.ru;
    const categoryOptions = Object.entries(currentTranslation.activityEntities).map(([value, label]) => ({
        value,
        label,
    }));
    const periodOptions = [
        { value: 'all', label: currentTranslation.filters.allTime },
        { value: 'today', label: currentTranslation.filters.today },
        { value: 'last_7_days', label: currentTranslation.filters.last7Days },
        { value: 'last_30_days', label: currentTranslation.filters.last30Days },
        { value: 'custom', label: currentTranslation.filters.custom },
    ];
    const actorOptions = ACTOR_TYPES.map(value => ({
        value,
        label: currentTranslation.actors[value] || value,
    }));
    const actionOptions = HISTORY_ACTIONS.map(value => ({
        value,
        label: currentTranslation.filters.actionOptions[value],
    }));

    const handleDraftFilterChange = useCallback((name, value) => {
        setDraftFilters(current => ({ ...current, [name]: value }));
        setFilterError('');
    }, []);

    const handlePeriodFilterChange = useCallback((name, value) => {
        handleDraftFilterChange(name, value || 'all');
    }, [handleDraftFilterChange]);

    const handleApplyFilters = () => {
        const nextFilters = resolveAppliedHistoryFilters(draftFilters);

        if (nextFilters.date_from && nextFilters.date_to && nextFilters.date_from > nextFilters.date_to) {
            setFilterError(currentTranslation.filters.invalidDateRange);
            return;
        }

        setFilterError('');
        logsCacheRef.current = createLogsCache(id, getHistoryFiltersKey(nextFilters));
        requestSequenceRef.current += 1;
        setCurrentPage(1);
        setAppliedFilters(nextFilters);
    };

    const handleResetFilters = () => {
        const emptyFilters = createAppliedHistoryFilters();

        setDraftFilters(createHistoryFilterDraft());
        setFilterError('');
        logsCacheRef.current = createLogsCache(id, getHistoryFiltersKey(emptyFilters));
        requestSequenceRef.current += 1;
        setCurrentPage(1);
        setAppliedFilters(emptyFilters);
    };

    const getIconType = (log) => {
        switch (log.type) {
            case 'CREATED':
                return 'create';
            case 'UPDATED':
                return 'update';
            case 'DELETED':
                return 'delete';
            default:
                return 'default';
        }
    };

    const getIconColor = (type) => {
        if (theme === 'dark') {
            switch (type) {
                case 'create':
                    return styles.darkGreenIcon;
                case 'update':
                    return styles.darkYellowIcon;
                case 'delete':
                    return styles.darkRedIcon;
                default:
                    return styles.darkDefaultIcon;
            }
        }
        switch (type) {
            case 'create':
                return styles.greenIcon;
            case 'update':
                return styles.yellowIcon;
            case 'delete':
                return styles.redIcon;
            default:
                return styles.defaultIcon;
        }
    };

    const formatAdminName = (admin) => {
        if (admin) {
            return `${admin.first_name || ''} ${admin.last_name || ''}`.trim() || admin.email;
        }
        return currentTranslation.system;
    };

    const formatLegacyActor = (log) => {
        if (log.created_by_admin) {
            return formatAdminName(log.created_by_admin);
        }

        return log.created_by_affiliator?.affiliate || currentTranslation.system;
    };

    const formatActivityActor = (log) => {
        const actorType = String(log.actor_type || '').toLowerCase();
        const actorLabel = currentTranslation.actors[actorType];

        if (!actorLabel) {
            return currentTranslation.system;
        }

        return log.actor_id ? `${actorLabel} #${log.actor_id}` : actorLabel;
    };

    const formatActivityValue = (value) => {
        if (value === null || value === undefined || value === '') {
            return currentTranslation.emptyValue;
        }

        if (typeof value === 'object') {
            return JSON.stringify(value);
        }

        return String(value);
    };

    const activityEventKey = (event) => String(event || '').split('.').slice(1).join('.');

    const resolveActivityVerb = (eventKey) => {
        const eventTranslations = currentTranslation.activityEvents;
        if (eventTranslations[eventKey]) {
            return eventTranslations[eventKey];
        }

        const fallbackKey = Object.keys(eventTranslations)
            .sort((left, right) => right.length - left.length)
            .find(key => eventKey.endsWith(key));

        return fallbackKey
            ? eventTranslations[fallbackKey]
            : eventKey.replaceAll('_', ' ');
    };

    const formatActivityActionAndDetails = (log) => {
        const eventKey = activityEventKey(log.event);
        const action = resolveActivityVerb(eventKey);
        const entity = currentTranslation.activityEntities[log.category]
            || String(log.category || '').toLowerCase();
        const actionText = ['logged_in', 'logged_out'].includes(eventKey)
            ? action
            : `${action} ${entity}`.trim();

        if (log.category === 'COMMENT') {
            const comment = log.after?.comment ?? log.before?.comment;
            if (comment) {
                return { action: actionText, details: comment };
            }
        }

        const lifecycleOnly = ['created', 'deleted', 'opened', 'uploaded', 'started']
            .some(lifecycle => eventKey === lifecycle || eventKey.endsWith(`_${lifecycle}`));
        let changedFields = Array.isArray(log.context?.changed_fields)
            ? log.context.changed_fields
            : [];

        if (!lifecycleOnly && changedFields.length === 0) {
            changedFields = Array.from(new Set([
                ...Object.keys(log.before || {}),
                ...Object.keys(log.after || {}),
            ]));
        }

        const comparableFields = changedFields.filter(field => (
            Object.prototype.hasOwnProperty.call(log.before || {}, field)
            || Object.prototype.hasOwnProperty.call(log.after || {}, field)
        ));

        if (comparableFields.length > 0) {
            return {
                action: actionText,
                details: (
                    <>
                        {comparableFields.map(field => (
                            <div key={field}>
                                <strong>{currentTranslation.properties[field] || field.replaceAll('_', ' ')}:</strong>{' '}
                                <span className={styles.oldValue}>{formatActivityValue(log.before?.[field])}</span>
                                <span className={styles.arrowSeparator}>&rarr;</span>
                                <span className={styles.newValue}>{formatActivityValue(log.after?.[field])}</span>
                            </div>
                        ))}
                    </>
                ),
            };
        }

        const relatedDetails = log.related_entity_id
            ? `${currentTranslation.relatedEntity}: ${log.related_entity_type || entity} #${log.related_entity_id}`
            : '';

        return { action: actionText, details: relatedDetails };
    };

    const getActivityIconType = (log) => {
        const eventKey = activityEventKey(log.event);

        if (['created', 'opened', 'uploaded', 'verified', 'activated', 'started', 'connected', 'logged_in']
            .some(action => eventKey === action || eventKey.endsWith(`_${action}`))) {
            return 'create';
        }

        if (['deleted', 'closed', 'failed', 'rejected', 'deactivated', 'terminated', 'logged_out']
            .some(action => eventKey === action || eventKey.endsWith(`_${action}`))) {
            return 'delete';
        }

        return 'update';
    };

    const formatActionAndDetails = (log) => {
        const t = currentTranslation.actions;
        const p = currentTranslation.properties;
        const emptyValue = currentTranslation.emptyValue;

        switch (log.data_type) {
            case 'COMMENT':
                switch (log.type) {
                    case 'CREATED':
                        return { action: t.createdComment, details: log.comment || '' };
                    case 'UPDATED':
                        return { action: t.updatedComment, details: log.comment || '' };
                    case 'DELETED':
                        return { action: t.deletedComment, details: log.comment || '' };
                    default:
                        return { action: t.updatedComment, details: log.comment || '' };
                }
            case 'LEAD':
                if (log.type === 'CREATED') {
                    const creatorName = log.created_by_admin ? formatAdminName(log.created_by_admin) : (log.created_by_affiliator ? log.created_by_affiliator.affiliate : currentTranslation.system);
                    return { action: t.createdLead, details: `${t.createdBy} ${creatorName}` };
                } else if (log.type === 'UPDATED' && log.property) {
                    let oldValue = log.old_value || emptyValue;
                    let newValue = log.new_value || emptyValue;

                    if (log.property.includes('created_at') || log.property.includes('updated_at') || log.property.includes('date')) {
                        oldValue = formatDateTime(oldValue);
                        newValue = formatDateTime(newValue);
                    }

                    return {
                        action: t.updatedLeadField,
                        details: (
                            <>
                                <strong>{log.property}:</strong>{' '}
                                <span className={styles.oldValue}>{oldValue}</span>
                                <span className={styles.arrowSeparator}>&rarr;</span>
                                <span className={styles.newValue}>{newValue}</span>
                            </>
                        )
                    };
                }
                return { action: log.type === 'CREATED' ? t.createdLead : `(${log.type.toLowerCase()})`, details: '' };
            case 'BALANCE':
                return {
                    action: log.type === 'CREATED' ? t.createdBalance : t.updatedBalance,
                    details: (
                        <>
                            <strong>{p.balance}:</strong>{' '}
                            <span className={styles.oldValue}>{log.old_balance || 'N/A'}</span>
                            <span className={styles.arrowSeparator}>&rarr;</span>
                            <span className={styles.newValue}>{log.new_balance || 'N/A'}</span>
                        </>
                    )
                };
            case 'VERIFICATION':
                return { action: log.type === 'CREATED' ? t.createdVerification : t.updatedVerification, details: log.comment || '' };
            case 'TRADE':
                return { action: log.type === 'CREATED' ? t.createdTrade : t.updatedTrade, details: log.comment || '' };
            case 'TRANSACTION':
                return { action: log.type === 'CREATED' ? t.createdTransaction : t.updatedTransaction, details: log.comment || '' };
            default:
                return { action: log.type.toLowerCase(), details: log.comment || '' };
        }
    };

    const formatLegacyLog = (log) => {
        const { action, details } = formatActionAndDetails(log);

        return {
            id: `legacy-${log.data_type}-${log.id}`,
            category: log.data_type,
            admin: formatLegacyActor(log),
            action,
            details,
            date: formatDateTime(log.created_at),
            iconType: getIconType(log),
        };
    };

    const formatActivityLog = (log) => {
        const { action, details } = formatActivityActionAndDetails(log);

        return {
            id: `activity-${log.id}`,
            category: log.category,
            admin: formatActivityActor(log),
            action,
            details,
            date: formatDateTime(log.occurred_at || log.created_at),
            iconType: getActivityIconType(log),
        };
    };

    const fetchLeadLogs = useCallback(async (page) => {
        const requestSequence = ++requestSequenceRef.current;
        const filtersKey = getHistoryFiltersKey(appliedFilters);
        setLoading(true);
        setErrors({});

        if (logsCacheRef.current.leadId !== id || logsCacheRef.current.filtersKey !== filtersKey) {
            logsCacheRef.current = createLogsCache(id, filtersKey);
        }

        const cache = logsCacheRef.current;
        const sources = [
            { key: 'activity', fetchPage: getLeadActivitiesApi },
            { key: 'legacy', fetchPage: getLeadLogsApi },
        ];

        try {
            const requests = [];

            sources.forEach(({ key, fetchPage }) => {
                const sourceCache = cache[key];
                const lastPage = sourceCache.totalPages === null
                    ? page
                    : Math.min(page, sourceCache.totalPages);

                for (let pageNumber = 1; pageNumber <= lastPage; pageNumber++) {
                    if (!sourceCache.pages.has(pageNumber)) {
                        requests.push(
                            fetchPage(id, pageNumber, itemsPerPage, appliedFilters)
                                .then(result => ({ key, pageNumber, result }))
                        );
                    }
                }
            });

            const results = await Promise.allSettled(requests);
            if (requestSequence !== requestSequenceRef.current) {
                return;
            }

            results.forEach(result => {
                if (result.status !== 'fulfilled') {
                    return;
                }

                const { key, pageNumber, result: response } = result.value;
                cache[key].pages.set(pageNumber, Array.isArray(response.data) ? response.data : []);
                cache[key].totalPages = response.meta.total_pages || 1;
                cache[key].totalItems = response.meta.total_count || 0;
            });

            const failedRequest = results.find(result => result.status === 'rejected');
            if (failedRequest) {
                const error = failedRequest.reason;
                handleError(error.response?.data || error, setErrors);
            }

            const mergedLogs = sources.flatMap(({ key }) => (
                Array.from(cache[key].pages.entries())
                    .filter(([pageNumber]) => pageNumber <= page)
                    .sort(([leftPage], [rightPage]) => leftPage - rightPage)
                    .flatMap(([, logs]) => logs.map(log => ({ log, source: key })))
            )).sort((left, right) => {
                const leftDate = left.source === 'activity'
                    ? left.log.occurred_at || left.log.created_at
                    : left.log.created_at;
                const rightDate = right.source === 'activity'
                    ? right.log.occurred_at || right.log.created_at
                    : right.log.created_at;
                const dateDifference = getLogTimestamp(rightDate) - getLogTimestamp(leftDate);

                if (dateDifference !== 0) {
                    return dateDifference;
                }

                if (left.source !== right.source) {
                    return left.source === 'activity' ? -1 : 1;
                }

                return Number(right.log.id || 0) - Number(left.log.id || 0);
            });

            const combinedTotal = sources.reduce((total, { key }) => total + cache[key].totalItems, 0);
            const combinedTotalPages = Math.max(1, Math.ceil(combinedTotal / itemsPerPage));
            const pageStart = (page - 1) * itemsPerPage;
            const pageLogs = mergedLogs.slice(pageStart, pageStart + itemsPerPage);

            setActivityLog(pageLogs);
            setExpandedLogIds(new Set());
            setTotalPages(combinedTotalPages);
            setTotalItems(combinedTotal);
        } catch (error) {
            if (requestSequence === requestSequenceRef.current) {
                handleError(error.response?.data || error, setErrors);
                setActivityLog([]);
                setTotalPages(1);
                setTotalItems(0);
            }
        } finally {
            if (requestSequence === requestSequenceRef.current) {
                setLoading(false);
            }
        }
    }, [appliedFilters, id, itemsPerPage]);

    useEffect(() => {
        logsCacheRef.current = createLogsCache(id);
        requestSequenceRef.current += 1;
        setCurrentPage(1);
    }, [id]);

    useEffect(() => {
        fetchLeadLogs(currentPage);
    }, [fetchLeadLogs, currentPage]);

    const handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= totalPages) {
            setCurrentPage(newPage);
        }
    };

    const toggleLogDetails = (logId) => {
        setExpandedLogIds(currentIds => {
            const nextIds = new Set(currentIds);

            if (nextIds.has(logId)) {
                nextIds.delete(logId);
            } else {
                nextIds.add(logId);
            }

            return nextIds;
        });
    };

    const renderPagination = () => {
        const pageNumbers = [];
        const maxPageButtons = 5;
        let startPage = Math.max(1, currentPage - Math.floor(maxPageButtons / 2));
        let endPage = Math.min(totalPages, startPage + maxPageButtons - 1);

        if (endPage - startPage + 1 < maxPageButtons) {
            startPage = Math.max(1, endPage - maxPageButtons + 1);
        }

        for (let i = startPage; i <= endPage; i++) {
            pageNumbers.push(i);
        }

        return (
            <div className={`${styles.pagination} ${theme === 'dark' ? styles.darkPagination : ''}`}>
                <button
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1 || loading}
                    className={`${styles.paginationButton} ${theme === 'dark' ? styles.darkPaginationButton : ''}`}
                >
                    {currentTranslation.previousPage}
                </button>
                {startPage > 1 && <span className={`${styles.paginationEllipsis} ${theme === 'dark' ? styles.darkPaginationEllipsis : ''}`}>...</span>}
                {pageNumbers.map((number) => (
                    <button
                        key={number}
                        onClick={() => handlePageChange(number)}
                        className={`${styles.paginationButton} ${currentPage === number ? styles.active : ''} ${theme === 'dark' ? styles.darkPaginationButton : ''} ${currentPage === number ? styles.darkActivePaginationButton : ''}`}
                        disabled={loading}
                    >
                        {number}
                    </button>
                ))}
                {endPage < totalPages && <span className={`${styles.paginationEllipsis} ${theme === 'dark' ? styles.darkPaginationEllipsis : ''}`}>...</span>}
                <button
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPages || loading}
                    className={`${styles.paginationButton} ${theme === 'dark' ? styles.darkPaginationButton : ''}`}
                >
                    {currentTranslation.nextPage}
                </button>
                <span className={`${styles.totalItems} ${theme === 'dark' ? styles.darkTotalItems : ''}`}>{currentTranslation.totalItems} {totalItems}</span>
            </div>
        );
    };

    if (loading) {
        return <LoadingCircle size={30} thickness={1} />;
    }

    const formattedLogs = activityLog.map(({ log, source }) => (
        source === 'activity' ? formatActivityLog(log) : formatLegacyLog(log)
    ));
    const activityLogClass = `${styles.activityLog} ${theme === 'dark' ? styles.darkActivityLog : ''}`;

    return (
        <div className={styles.historyPageContainer}>
            {errors.general && <Notification message={errors.general} type={"error"} />}
            <section className={`${styles.filtersPanel} ${theme === 'dark' ? styles.darkFiltersPanel : ''}`}>
                <div className={styles.filtersHeader}>
                    <h3 className={`${styles.filtersTitle} ${theme === 'dark' ? styles.darkFiltersTitle : ''}`}>
                        <FilterListOutlinedIcon className={styles.filtersTitleIcon} />
                        {currentTranslation.filters.title}
                    </h3>
                    <div className={styles.filterActions}>
                        <button
                            type="button"
                            className={`${styles.resetFiltersButton} ${theme === 'dark' ? styles.darkResetFiltersButton : ''}`}
                            onClick={handleResetFilters}
                        >
                            <RestartAltOutlinedIcon />
                            {currentTranslation.filters.reset}
                        </button>
                        <button
                            type="button"
                            className={styles.applyFiltersButton}
                            onClick={handleApplyFilters}
                        >
                            <CheckOutlinedIcon />
                            {currentTranslation.filters.apply}
                        </button>
                    </div>
                </div>

                <div className={styles.filtersGrid}>
                    <label className={`${styles.filterField} ${theme === 'dark' ? styles.darkFilterField : ''}`}>
                        <span>{currentTranslation.filters.period}</span>
                        <DropdownSelector
                            filterName="period"
                            selectedValue={draftFilters.period}
                            handleFilterChange={handlePeriodFilterChange}
                            options={periodOptions}
                        />
                    </label>

                    {draftFilters.period === 'custom' && (
                        <>
                            <label className={`${styles.filterField} ${theme === 'dark' ? styles.darkFilterField : ''}`}>
                                <span>{currentTranslation.filters.dateFrom}</span>
                                <input
                                    type="date"
                                    value={draftFilters.date_from}
                                    max={draftFilters.date_to || undefined}
                                    onChange={(event) => handleDraftFilterChange('date_from', event.target.value)}
                                    className={`${styles.dateInput} ${theme === 'dark' ? styles.darkDateInput : ''}`}
                                />
                            </label>
                            <label className={`${styles.filterField} ${theme === 'dark' ? styles.darkFilterField : ''}`}>
                                <span>{currentTranslation.filters.dateTo}</span>
                                <input
                                    type="date"
                                    value={draftFilters.date_to}
                                    min={draftFilters.date_from || undefined}
                                    onChange={(event) => handleDraftFilterChange('date_to', event.target.value)}
                                    className={`${styles.dateInput} ${theme === 'dark' ? styles.darkDateInput : ''}`}
                                />
                            </label>
                        </>
                    )}

                    <div className={styles.filterField}>
                        <span className={theme === 'dark' ? styles.darkFilterLabel : ''}>
                            {currentTranslation.filters.categories}
                        </span>
                        <MultiSelectDropdown
                            filterName="categories"
                            selectedValue={draftFilters.categories}
                            handleFilterChange={handleDraftFilterChange}
                            options={categoryOptions}
                            placeholder={currentTranslation.filters.categories}
                            closeOnSelect={false}
                        />
                    </div>

                    <div className={styles.filterField}>
                        <span className={theme === 'dark' ? styles.darkFilterLabel : ''}>
                            {currentTranslation.filters.initiators}
                        </span>
                        <MultiSelectDropdown
                            filterName="actor_types"
                            selectedValue={draftFilters.actor_types}
                            handleFilterChange={handleDraftFilterChange}
                            options={actorOptions}
                            placeholder={currentTranslation.filters.initiators}
                            closeOnSelect={false}
                        />
                    </div>

                    <div className={styles.filterField}>
                        <span className={theme === 'dark' ? styles.darkFilterLabel : ''}>
                            {currentTranslation.filters.actions}
                        </span>
                        <MultiSelectDropdown
                            filterName="actions"
                            selectedValue={draftFilters.actions}
                            handleFilterChange={handleDraftFilterChange}
                            options={actionOptions}
                            placeholder={currentTranslation.filters.actions}
                            closeOnSelect={false}
                        />
                    </div>
                </div>

                {filterError && <p className={styles.filterError} role="alert">{filterError}</p>}
            </section>
            <div className={activityLogClass}>
                {formattedLogs.length > 0 ? (
                    formattedLogs.map((log) => {
                        const isExpanded = expandedLogIds.has(log.id);
                        const detailsId = `log-details-${log.id}`;

                        return (
                            <div key={log.id} className={styles.logEntry}>
                                <div className={styles.logWrapper}>
                                    <div className={styles.routeContainer}>
                                        <p className={`${styles.routeLine} ${theme === 'dark' ? styles.darkRouteLine : ''}`}></p>
                                    </div>
                                    <div className={`${styles.icon} ${getIconColor(log.iconType)}`}>
                                        <LogCategoryIcon category={log.category} />
                                    </div>
                                </div>

                                <div className={`${styles.logContent} ${theme === 'dark' ? styles.darkLogContent : ''}`}>
                                    <div className={styles.logHeaderContainer}>
                                        <div className={styles.logHeaderBadges}>
                                            <span className={`${styles.logAdmin} ${theme === 'dark' ? styles.darkLogAdmin : ''}`}>{log.admin}</span>
                                            <span className={`${styles.logAction} ${theme === 'dark' ? styles.darkLogAction : ''}`}>{log.action}</span>
                                        </div>
                                        {log.details && (
                                            <button
                                                type="button"
                                                className={`${styles.detailsToggle} ${theme === 'dark' ? styles.darkDetailsToggle : ''}`}
                                                onClick={() => toggleLogDetails(log.id)}
                                                aria-expanded={isExpanded}
                                                aria-controls={detailsId}
                                            >
                                                {isExpanded ? currentTranslation.hideDetails : currentTranslation.showDetails}
                                                <ExpandMoreIcon
                                                    className={`${styles.expandIcon} ${isExpanded ? styles.expandedIcon : ''}`}
                                                    fontSize="small"
                                                />
                                            </button>
                                        )}
                                    </div>
                                    <div className={styles.logDateContainer}>
                                        <div className={`${styles.logDate} ${theme === 'dark' ? styles.darkLogDate : ''}`}>{log.date}</div>
                                    </div>
                                    {log.details && isExpanded && (
                                        <div id={detailsId} className={styles.logMainInfoContainer}>
                                            <div className={`${styles.logDetails} ${theme === 'dark' ? styles.darkLogDetails : ''}`}>
                                                {log.details}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        );
                    })
                ) : (
                    <div className={`${styles.noDataMessage} ${theme === 'dark' ? styles.darkNoDataMessage : ''}`}>
                        <p>{currentTranslation.noData}</p>
                        {errors.general && <p>{errors.general}</p>}
                    </div>
                )}
            </div>
            {totalPages > 1 && renderPagination()}
        </div>
    );
};

const createLogsCache = (leadId, filtersKey = '') => ({
    leadId,
    filtersKey,
    activity: { pages: new Map(), totalPages: null, totalItems: 0 },
    legacy: { pages: new Map(), totalPages: null, totalItems: 0 },
});

const getHistoryFiltersKey = (filters) => JSON.stringify(filters);

const resolveAppliedHistoryFilters = (draftFilters) => {
    const dates = getPresetDateRange(draftFilters.period);

    return {
        date_from: draftFilters.period === 'custom' ? draftFilters.date_from : dates.date_from,
        date_to: draftFilters.period === 'custom' ? draftFilters.date_to : dates.date_to,
        categories: [...draftFilters.categories],
        actor_types: [...draftFilters.actor_types],
        actions: [...draftFilters.actions],
    };
};

const getPresetDateRange = (period) => {
    if (period === 'all' || period === 'custom') {
        return { date_from: '', date_to: '' };
    }

    const today = new Date();
    const from = new Date(today);

    if (period === 'last_7_days') {
        from.setDate(from.getDate() - 6);
    } else if (period === 'last_30_days') {
        from.setDate(from.getDate() - 29);
    }

    return {
        date_from: formatDateInput(from),
        date_to: formatDateInput(today),
    };
};

const formatDateInput = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
};

const getLogTimestamp = (value) => {
    const normalizedValue = String(value || '').trim();
    const parts = normalizedValue.match(/^(\d{2})-(\d{2})-(\d{4}) (\d{2}):(\d{2}):(\d{2})$/);

    if (parts) {
        return Date.UTC(
            Number(parts[3]),
            Number(parts[2]) - 1,
            Number(parts[1]),
            Number(parts[4]),
            Number(parts[5]),
            Number(parts[6]),
        );
    }

    const timestamp = Date.parse(normalizedValue);
    return Number.isNaN(timestamp) ? 0 : timestamp;
};

const LOG_CATEGORY_ICONS = {
    LEAD: PersonOutlineIcon,
    COMMENT: ChatBubbleOutlineIcon,
    BALANCE: AccountBalanceWalletOutlinedIcon,
    TRADE: ShowChartIcon,
    TRANSACTION: ReceiptLongOutlinedIcon,
    VERIFICATION: VerifiedUserOutlinedIcon,
    BOT: SmartToyOutlinedIcon,
    CALL: CallOutlinedIcon,
    CHAT: ForumOutlinedIcon,
    ACTIVITY: HistoryOutlinedIcon,
    DEPOSIT_METHOD: AccountBalanceOutlinedIcon,
    SYNC: SyncOutlinedIcon,
};

const LogCategoryIcon = ({ category }) => {
    const Icon = LOG_CATEGORY_ICONS[category] || HistoryOutlinedIcon;

    return <Icon fontSize="small" aria-hidden="true" />;
};
